import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { DialogHeaderModule } from '../../dialog/dialog-header/dialog-header.module';
import { ConfirmDialogComponent } from './confirm-dialog.component';

@NgModule({
  exports: [ConfirmDialogComponent],
  imports: [DialogHeaderModule, CommonModule, ConfirmDialogComponent],
})
export class ConfirmDialogModule {}
export { ConfirmDialogComponent } from './confirm-dialog.component';
